import React from "react";

import { ProgressMessage } from "../hooks/usePublishShiftsWithProgress";

interface Props {
  progressList: ProgressMessage[];
  scrollRef?: React.RefObject<HTMLDivElement>;
}

export function PublishProgressDisplay({ progressList, scrollRef }: Props) {
  React.useEffect(() => {
    // Auto-scroll to latest progress when it updates
    if (progressList.length > 0) {
      requestAnimationFrame(() => {
        if (scrollRef && scrollRef.current) {
          scrollRef.current.scrollIntoView({
            behavior: "smooth",
            block: "end",
          });
        }
      });
    }
  }, [progressList, scrollRef]);

  if (progressList.length === 0) {
    // Show a starting message when operation has begun but no progress yet
    return (
      <div className="my-1 px-3 py-2 bg-white border-primary border rounded list-disc text-primary-dark relative">
        <div>Starting publish operation...</div>
      </div>
    );
  }

  return (
    <div className="my-1 px-3 py-2 bg-white border-primary border rounded list-disc text-primary-dark relative">
      {progressList.map((p, i) => (
        <div key={i}>
          {p.state === "PROGRESS" && (
            <>
              {p.progress != null && (
                <span>
                  {p.progress} / {p.total}
                </span>
              )}{" "}
              {p.message}
            </>
          )}
          {p.state === "DONE" && <div className="text-success">Done</div>}
          {p.state === "WARNING" && <div className="text-warning">{p.message}</div>}
          {p.state === "ERROR" && (
            <div className="text-danger">
              <pre>{JSON.stringify(p.error, null, 2)}</pre>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
